var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 26",
    style: {
      enableBackground: "new 0 0 24 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.2,11.4c0-1.7-1.2-3-2.9-3.2c-0.4-0.1-0.8-0.1-1.2-0.1h-3.6V4.3c0-1-0.3-1.9-1-2.5c-0.7-0.7-1.6-1-2.5-1H4.3 c-0.9-0.1-1.9,0.3-2.5,1s-1,1.6-1,2.5V24c0,0.4,0.1,0.7,0.4,0.9c0.3,0.2,0.7,0.2,1,0s0.5-0.5,0.4-0.9V4.3c0-0.5,0.1-0.9,0.5-1.3 c0.3-0.3,0.8-0.5,1.3-0.5H12c0.5,0,0.9,0.1,1.2,0.4s0.5,0.8,0.5,1.2v3.6c0,0.1,0,0.2,0,0.2H8.3c-1-0.1-2,0.3-2.7,1s-1.1,1.7-1,2.7 V24c0,0.5,0.4,0.8,0.9,0.8s0.9-0.4,0.9-0.8v-3.2c0-3,0-6.1,0-9.2c0-0.5,0.2-0.9,0.5-1.3C7.2,10,7.7,9.8,8.2,9.8h5.3h6 c1.2,0,1.8,0.6,1.8,1.8V24c0,0.5,0.4,0.9,0.9,0.9s0.9-0.4,0.9-0.9v-2.9C23.2,17.9,23.2,14.6,23.2,11.4z M17.3,24.4h2.1v-3.9h-2.1 V24.4z M7.1,4.6H5v2.1h2.1V4.6z M9.4,4.6v2.1h2.1V4.6H9.4z M10.5,11.9H8.4V14h2.1V11.9z M12.9,11.9V14H15v-2.1H12.9z M8.4,18.3h2.1 v-2.1H8.4V18.3z M12.9,18.3H15v-2.1h-2.1V18.3z M17.3,18.3h2.1v-2.1h-2.1V18.3z M8.4,22.6h2.1v-2.1H8.4V22.6z M12.9,22.5H15v-2.1 h-2.1V22.5z M19.5,12h-2.1v2h2.1V12z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBuilding);
export default __webpack_public_path__ + "static/media/ico-building.218b5f27370c925a9a34c708c8fb25b3.svg";
export { ForwardRef as ReactComponent };